import React from "react";
import Index from "../Index";

function AuthFooter() {
  return (
    <footer className="new-auth-footer">
      <div className="new-auth-footer-content">

        <div className="new-auth-footer-brand">
          <img src={Index.Png.Logo} alt="Logo" className="new-auth-footer-logo" />
          <p className="new-auth-footer-desc">
            Garment Pro is a cloud-based ERP solution tailored for the garment industry, helping businesses streamline operations, improve accuracy, and grow with confidence.
          </p>
        </div>

        <div className="new-auth-footer-divider"></div>

        <div className="new-auth-footer-col">
          <h4 className="new-auth-footer-col-title">Modules</h4>
          <div className="footer-split-list">
            <ul className="new-auth-footer-list">
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg> Sales
              </li>
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg> Purchase
              </li>
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg> Inventory
              </li>
            </ul>
            <ul className="new-auth-footer-list">
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg> Accounts
              </li>
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg> GST/Compliance
              </li>
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg> Reports
              </li>
            </ul>
          </div>
        </div>

        <div className="new-auth-footer-divider"></div>

        <div className="new-auth-footer-col">
          <h4 className="new-auth-footer-col-title">Why Garment Pro?</h4>
          <div className="footer-split-list">
            <ul className="new-auth-footer-list">
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3z" /></svg> Cloud-Based & Secure
              </li>
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" /></svg> Real-time Insights
              </li>
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" /></svg> Easy to Use
              </li>
            </ul>
            <ul className="new-auth-footer-list">
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" /></svg> Multi-user Support
              </li>
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M9 12l2 2 4-4m5.61-3.22A10 10 0 0 0 12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.2-.72-4.24-1.93-5.9" /></svg> GST Compliant
              </li>
              <li>
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeWidth="2" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-18v5m0 6v5m-8-8h5m6 0h5" /></svg> Scalable Anytime
              </li>
            </ul>
          </div>
        </div>

        <div className="new-auth-footer-divider"></div>

        <div className="new-auth-footer-col footer-col-connect">
          <h4 className="new-auth-footer-col-title">Connect With Us</h4>
          <ul className="new-auth-footer-list">
            <li>
              <a href="tel:+911234567890" className="footer-link-item">
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" /></svg> +91 12345 67890
              </a>
            </li>
            <li>
              <a href="mailto:info@gramentpro.com" className="footer-link-item">
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" /></svg> info@gramentpro.com
              </a>
            </li>
            <li>
              <a href="https://www.garmentpro.com" target="_blank" rel="noopener noreferrer" className="footer-link-item">
                <svg className="footer-svg-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.33-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm-.3-8c.96-1.65 2.49-2.93 4.33-3.56-.6 1.11-1.06 2.31-1.38 3.56H5.08zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.34-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.33.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" /></svg> www.garmentpro.com
              </a>
            </li>
          </ul>
        </div>

      </div>
      <div className="new-auth-footer-bottom">
        <p>
          <span>© 2025 Garment Pro. All rights reserved.</span>
          <span className="footer-bottom-separator">|</span>
          <Index.Link to="/privacy">Privacy Policy</Index.Link>
          <span className="footer-bottom-separator">|</span>
          <Index.Link to="/terms">Terms & Conditions</Index.Link>
        </p>
      </div>
    </footer>
  );
}

export default AuthFooter;
